import Tooltip from '@atlaskit/tooltip';
import isNil from 'lodash/isNil';
import React from 'react';
import { abbreviateNumber, fullNumber } from "../../../../utils/numberFormatting.utils";

const AbbreviatedNumberTooltip = ({
  value
}) => isNil(value) ? '--' : /*#__PURE__*/React.createElement(Tooltip, {
  content: fullNumber(value)
}, /*#__PURE__*/React.createElement("span", null, abbreviateNumber(value)));

export default AbbreviatedNumberTooltip;